import React from "react";
import Social from "./Socials";
import { useTranslation } from "react-i18next";

const Slider = (props) => {
  const { t } = useTranslation("clientSite"); // expects keys under "header.*"
  return (
    <>
      {/*  Home Banner */}
      <section
        id="home"
        className="banner-top overlay overlay-65"
        style={{backgroundImage: props.site.headerFilename === null ? `url(${
             process.env.PUBLIC_URL + "defaultSliderImage.jpg"
          })` :  `url(${
             process.env.REACT_APP_API_SERVICE_BASE_URL + "image/SiteHeaderImages/" + props.site.headerFilename
          })`}}
      >

          {/* backgroundImage: `url(${
             "https://localhost:51068/api/v1/image/" + "SiteHeaderImages/" + props.site.headerFilename
          })`,

          backgroundImage: `url(${
             process.env.PUBLIC_URL + "hair.jpg"
          })`, */}


        <div className="frame-layout__particles"></div>
        {/* End particle animation */}
        <div className="container">
          <div className="row align-items-center full-screen" style={{width:"80%", marginLeft:"auto", marginRight:"auto"}}>
            <div className="col-lg-12">
              {props.site.siteNoticeEnabled ?
                <div className="site-notice-box">
                  <h4 style={{textAlign:"center", paddingTop:"0.6rem"}}>{props.site.siteNoticeTitle}</h4>
                  <p className="site-notice-text">{props.site.siteNoticeDescription}</p>
                </div>
                :
                <></>
              }

              <div className="hb-typo text-center" style={{backdropFilter:"blur(10px)"}}>
                <div className="section-title" style={{paddingBottom:0}}>
                <h1
                style={{paddingTop:"5rem"}}
                  className=""
                //   data-aos="fade-up"
                  data-aos-duration="1200"
                  data-aos-delay="100"
                >
                  {props.site.siteTitle}
                </h1>
                </div>
                <div>
                  <a target="_blank" style={{marginTop:"5rem", marginBottom:"5rem"}} className="px-btn px-btn-theme btn-md" href={"make-a-booking?id=" + props.site.barberShopId}>
                    {t("bookNow")}
                  </a>
                </div>
              </div>
            </div>
          </div>
        </div>

        <Social site={props.site} />
        {/* End social slide  */}
      </section>
      {/* End Home Banner  */}
    </>
  );
};

export default Slider;
